import apiClient from "./apiClient";

export const getPetOwners = (page = 1, limit = 10, search="") => apiClient
    .get("/petowners", { params: { page, limit, search } })
    .then(res => res);

export const getPetOwnersByOfficeId = (id) => apiClient.get(`/petowners/office/${id}`);
export const getPetOwnerById = (id) => apiClient.get(`/petowners/${id}`);
export const createPetOwner = (data) => apiClient.post("/petowners", data);
export const updatePetOwner = (id, data) => apiClient.put(`/petowners/${id}`, data);
export const deletePetOwner = (id) => apiClient.delete(`/petowners/${id}`);